import { UserState } from './types';

export const initialState: UserState = {
  idToken: null,
  refreshToken: null,
  user: null,
  signingOut: false,
  changingChannels: false,
};
